import { render, staticRenderFns } from "./Projector.vue?vue&type=template&id=0f9f1ab8&scoped=true&lang=pug&"
import script from "./Projector.vue?vue&type=script&lang=js&"
export * from "./Projector.vue?vue&type=script&lang=js&"
import style0 from "./Projector.vue?vue&type=style&index=0&id=0f9f1ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9f1ab8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VChip,VIcon,VImg})
